import createIcon from '../../createIcon';

/**
 * @component @name RampLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNSAyMUg5LjVWNi44M0w3LjkxIDguNDFMNi41IDdMMTAuNSAzTDE0LjUgN0wxMy4wOSA4LjQxTDExLjUgNi44M1Y5QzExLjUgMTMuMjcgMTUuNTMgMTYuMTMgMTcuNSAxNy4yN0wxNi4wNCAxOC43M0MxNC4xMyAxNy41NyAxMi42IDE2LjIgMTEuNSAxNC43MVYyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RampLeft = createIcon('RampLeft', [
  [
    'path',
    {
      d: 'M11.5 21H9.5V6.83L7.91 8.41L6.5 7L10.5 3L14.5 7L13.09 8.41L11.5 6.83V9C11.5 13.27 15.53 16.13 17.5 17.27L16.04 18.73C14.13 17.57 12.6 16.2 11.5 14.71V21Z',
      key: '189grq',
    },
  ],
]);

export default RampLeft;
